import { ChartCandleIcon } from '@/ui/Icons/ChartCandleIcon';
import { ChartLineIcon } from '@/ui/Icons/ChartLineIcon';

import type { ChartColor } from './types';

export const CHART_TYPE_OPTIONS = [
  { label: <ChartLineIcon />, ariaLabel: 'Line chart', value: 'area' as const },
  { label: <ChartCandleIcon />, ariaLabel: 'Candlestick chart', value: 'candlestick' as const },
];

export const CANDLESTICK_SUMMARY_FIELDS = [
  { label: 'O', property: 'open' },
  { label: 'H', property: 'high' },
  { label: 'L', property: 'low' },
  { label: 'C', property: 'close' },
] as const;

export const TOKEN_PRICE_SUMMARY_TOP_PADDING_RATIO = 0.2;
export const CANDLESTICK_SUMMARY_TOP_PADDING_RATIO = 0.35;

export const CHART_COLORS: Record<
  'positive' | 'negative' | 'neutral',
  { lineColor: ChartColor; gradientColor: ChartColor }
> = {
  positive: { lineColor: 'green-1000', gradientColor: 'green-300' },
  negative: { lineColor: 'red-900', gradientColor: 'red-300' },
  neutral: { lineColor: 'gray-600', gradientColor: 'gray-300' },
};
